import React, { Fragment } from 'react';
import { TitleBar } from 'styles/layout/titlebar';
import useTitle from 'hooks/useTitle';
import { Content } from 'styles/globalStyles';
import { useHistory } from 'react-router-dom';
import JsxHelper from 'helpers/jsx';
import PartnerHelper from 'helpers/partner';

const Websites = () => {
  useTitle('Settings');
  const history = useHistory();

  const BREADCRUMBS = JsxHelper.createBreadcrumbs('Settings')

  const handleOnClick = (e) => history.push({ pathname: `/settings/${e}`, })

  return (
    <Fragment>
      <TitleBar>
        <TitleBar.Title breadcrumbs={BREADCRUMBS}>Settings</TitleBar.Title>
      </TitleBar>
      <Content>
        {JsxHelper.createAdvancedTabs(
          PartnerHelper.getGlobalSettings(),
          handleOnClick,
        )}
      </Content>
    </Fragment>
  );
};

export default Websites;
